import React from 'react';

const DocumentVersion = ({
    canIssue,
    canRevision,
    issue,
    revision,
}) => {
    if(!canIssue && !canRevision) {
        return null
    }

    const value = (canIssue && issue ? issue : '') + (canRevision && revision ? revision : '')
    const comment = canIssue && canRevision
        ? 'Issue and Revision'
        : canIssue
            ? 'Issue'
            : 'Revision'

    return (
        <div className="form-group">
            <label className="col-sm-2 control-label">Version</label>
            <div className="col-sm-8">
                <input className="form-control"
                    type="text"
                    name="document_version"
                    value={value}
                    disabled
                />
                <span className="help-block m-b-none m-t-none">
                    <small className="form-info-text"> {comment}</small>
                </span>
            </div>
        </div>
    )
}
export default DocumentVersion
